import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import DashboardPage from '../components/DashboardPage';

const META = {
  skills_development: {
    title: 'Skills Development',
    scorecardPath: '/skills-development/scorecard',
    submitPath: '/skills-development/submit-datasheet',
  },
  skills_development_transport: {
    title: 'Skills Development (Transport)',
    scorecardPath: '/skills-development/scorecard/skills-development-transport',
    submitPath: '/skills-development/submit-datasheet/skills-development-transport',
  },
  skills_development_specialised: {
    title: 'Skills Development (Specialised)',
    scorecardPath: '/skills-development/scorecard/skills-development-specialised',
    submitPath: '/skills-development/submit-datasheet/skills-development-specialised',
  },
};

const SkillsDevelopment = () => {
  const navigate = useNavigate();
  const { elementKey: rawElementKey } = useParams();
  const elementKey = (rawElementKey || 'skills_development').replace(/-/g, '_');
  const meta = META[elementKey] || META.skills_development;

  const actions = [
    {
      label: 'Submit Data Sheet',
      onClick: () => navigate(meta.submitPath),
      desc: 'Enter and submit scorecard data',
      icon: (
        <svg viewBox="0 0 24 24">
          <line x1="22" y1="2" x2="11" y2="13"/>
          <polygon points="22 2 15 22 11 13 2 9 22 2"/>
        </svg>
      ),
    },
    {
      label: 'Documentation Upload',
      onClick: () => navigate(`/skills-development/documentation/${elementKey}`),
      desc: 'Upload data for scorecard compliance',
      icon: (
        <svg viewBox="0 0 24 24">
          <line x1="12" y1="1" x2="12" y2="23"/>
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
        </svg>
      ),
    },
    {
      label: 'Skills Development Scorecard',
      onClick: () => navigate(meta.scorecardPath),
      desc: 'Skills Development scorecard data and compliance tracking',
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/>
          <rect x="9" y="3" width="6" height="4" rx="1"/>
          <line x1="9" y1="12" x2="15" y2="12"/>
          <line x1="9" y1="16" x2="13" y2="16"/>
        </svg>
      ),
    },
    {
      label: 'Training Plans',
      desc: 'Workforce skills plan (WSP) management',
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
          <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
        </svg>
      ),
    },
    {
      label: 'Learnerships',
      desc: 'Learnership agreements and progress',
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
          <path d="M6 12v5c3 3 9 3 12 0v-5"/>
        </svg>
      ),
    },
    {
      label: 'Bursaries',
      desc: 'Bursary awards and beneficiary records',
      icon: (
        <svg viewBox="0 0 24 24">
          <circle cx="12" cy="8" r="6"/>
          <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/>
        </svg>
      ),
    },
    
    {
      label: 'Skills Levies',
      desc: 'SDL contribution and recovery records',
      icon: (
        <svg viewBox="0 0 24 24">
          <line x1="12" y1="1" x2="12" y2="23"/>
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
        </svg>
      ),
    },
    {
      label: 'SETA Registration',
      desc: 'SETA accreditation and registration details',
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
          <polyline points="9 12 11 14 15 10"/>
        </svg>
      ),
    },
    {
      label: 'Reports',
      desc: 'Annual training and skills reports',
      onClick: () => navigate('/reports/skills-development'),
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
          <line x1="16" y1="13" x2="8" y2="13"/>
          <line x1="16" y1="17" x2="8" y2="17"/>
        </svg>
      ),
    },
  ];

  return (
    <DashboardPage
      theme={elementKey}
      title="Skills Development"
      subtitle="B-BBEE Scorecard — Skills Development Element"
      actions={actions}
    />
  );
};

export default SkillsDevelopment;
